<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      //- small {{ operatorID }} 
      .form-group.col-md-5.col-4.mb-1
        b-input-group(size="sm")
          b-form-select.col-4(v-model="searchType" size="sm" @change="initSearchData()")
            option(value="account_id") {{ $t('ui.account_id') }}
            option(value="affiliate_code") {{ $t('ui.affiliate_code') }}
            option(value="contact_phone") {{ $t('ui.contact_phone') }}
            option(value="account_status") {{ $t('ui.status') }}
          template(v-if="['account_id','affiliate_code','contact_phone'].includes(searchType)")
            DebounceInput(autofocus type="text" v-model="searchData" :placeholder="$t('message.search_by_' + searchType)" @enter="getListing()" size="sm")
          template(v-else)
            b-form-select.col-4(v-model="accountStatus" size="sm" @change="getListing()")
              option(value="") {{ $t('ui.all') }}
              option(value="ACTIVE") {{ $t('ui.active') }}
              option(value="CLOSE") {{ $t('ui.close') }}
              option(value="SUSPEND") {{ $t('ui.suspend') }}
      .form-group.col-6.mb-1(v-if="!['account_status'].includes(searchType)")
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getListing()"
          variant="primary"
          size="sm"
        )
  .card-body
    .row
      .col-md-12.col-12
        b-breadcrumb
          b-breadcrumb-item(
            @click="drillIn('company')"
          )
            span {{ accountID }}
          b-breadcrumb-item(
            v-for="(item,index) in lines"
            :key="index"
            :text="item.account_id"
            :class="{ active : index == lines.length - 1 }"
            @click="drillIn(item, 'affiliate')"
          )
    .row(v-if="selectedAffiliateAccType < 10")
      .col-12
        .card.card-primary
          .card-header
            i.fa.fa-user-tie
            span.ml-1.font-weight-bold(:title="$t('ui.affiliate')") {{ $t("ui.affiliate") }}
          .card-body
            .row
              .col-md-10.col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRowAff"
                  :per-page="getPageSize"
                  v-model="currentPageAff"
                  @input="changedPageAff($event)")
              .col-md-2.col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSizeAff" size="sm")
              .col-md-12.col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="7%" @click="sortOrder('account_id','aff')")
                          span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                          .float-right
                            i(:class="changeSortKey('account_id','aff')")
                        th(@click="sortOrder('full_name','aff')" width="6%")
                          span(:title="$t('ui.full_name')") {{ $t("ui.full_name") }}
                          .float-right
                            i(:class="changeSortKey('full_name','aff')")
                        th(width="6%" @click="sortOrder('contact_phone','aff')")
                          span(:title="$t('ui.contact_phone')") {{ $t("ui.contact_phone") }}
                          .float-right
                            i(:class="changeSortKey('contact_phone','aff')")
                        th(width="5%" @click="sortOrder('signup_ip','aff')")
                          span(:title="$t('ui.signup_ip')") {{ $t("ui.signup_ip") }}
                          .float-right
                            i(:class="changeSortKey('signup_ip','aff')")
                        th(width="6%" @click="sortOrder('affiliate_code','aff')")
                          span(:title="$t('ui.affiliate_code')") {{ $t("ui.affiliate_code") }}
                          .float-right
                            i(:class="changeSortKey('affiliate_code','aff')")
                        th.text-center(width="5%" @click="sortOrder('status','aff')")
                          span(:title="$t('ui.status')") {{ $t("ui.status") }}
                          .float-right
                            i(:class="changeSortKey('status','aff')")
                        th.text-center(width="10%")
                          span(:title="$t('ui.action')") {{ $t("ui.action") }}
                        th(width="5%" @click="sortOrder('approved_by','aff')")
                          span(:title="$t('ui.approved_by')") {{ $t("ui.approved_by") }}
                          .float-right
                            i(:class="changeSortKey('approved_by','aff')")
                        th.text-right(width="7%" @click="sortOrder('approved_date','aff')")
                          span(:title="$t('ui.approved_date')") {{ $t("ui.approved_date") }}
                          .float-right
                            i(:class="changeSortKey('approved_date','aff')")
                        th.text-right(width="7%" @click="sortOrder('created_date','aff')")
                          span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                          .float-right
                            i(:class="changeSortKey('created_date','aff')")
                    tbody.clusterize-content
                      tr(v-if="affiliateList.length == 0")
                        td(colspan="11").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in affiliateList" :class="$helpers.rowClass(item)")
                        td.text-center
                          span(:title="((currentPageAff - 1) * getPageSize + index + 1)") {{ ((currentPageAff - 1) * getPageSize + index + 1) }}
                        td
                          span(:title="item.account_id")
                            b-link.clickable(href="javascript:void(0);" @click="drillIn(item, 'affiliate')") {{ item.account_id }}
                        td
                          span(:title="item.full_name") {{ item.full_name }}
                        td
                          span(:title="item.contact_phone") {{ item.contact_phone }}
                        td
                          span(:title="item.signup_ip") {{ item.signup_ip }}
                        td
                          span.d-block(:title="item.affiliate_code") {{ item.affiliate_code }}
                          span.small(:title="item.settlement_type") {{ item.settlement_type }}
                        td.text-center
                          span(:title="item.status" :class="$helpers.badgeClass(item.status)") {{ item.status }}
                        td.text-center
                          span(v-if="item.account_type == 1 && showActionButton('editaff')")
                            a.fa.fa-edit.btn.btn-ssm.btn-primary(href="javascript:void(0)" @click="onEditAffiliate(item)" :title="$t('ui.edit')")
                          span.ml-1(v-if="item.account_type == 1 && showActionButton('updatecarryoveraff')")
                            a.fas.fa-exchange-alt.btn.btn-ssm.btn-danger(href="javascript:void(0)" @click="onUpdateCarryOverAffiliate(item)" :title="$t('ui.update_carry_over')")
                          span.ml-1(v-if="showActionButton('walletadjustaff')")
                            a.fa.fa-sliders-h.btn.btn-ssm.btn-dark(href="javascript:void(0)" @click="onAdjustAffiliate(item)" :title="$t('ui.wallet_adjust')")
                          span.ml-1(v-if="showActionButton('updatecomissionaff')")
                            a.fas.fa-cubes.btn.btn-ssm.btn-info(href="javascript:void(0)" @click="onUpdateCommAffiliate(item)" :title="$t('ui.update_comm')")
                          span.ml-1(v-if="showActionButton('resetpasswordaff')")
                            a.fa.fa-lock.btn.btn-ssm.btn-warning(href="javascript:void(0)" @click="onResetPasswordAffiliate(item)" :title="$t('ui.reset_password')")
                          //- span
                          //-   a.fa.fa-user.text-success(href="javascript:void(0)" @click="onSubAccDetailAffiliate(item)" :title="$t('ui.sub_account_detail')")
                          span.ml-1(v-if="item.profile_status.toUpperCase() == 'BLOCK' && showActionButton('unblockaff')")
                            a.fa.fa-unlock.btn.btn-ssm.btn-danger(href="javascript:void(0)" @click="onUnblockAffiliate(item)" :title="$t('ui.unblock')")
                          span.ml-1
                            a.fa.fa-chart-line.btn.btn-ssm.btn-success(href="javascript:void(0)" @click="redirectAffReport(item)" :title="$t('ui.affiliate_report')")
                        td
                          span(:title="item.approved_by") {{ item.approved_by }}
                        td.text-right
                          span(:title="$moment(item.approved_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.approved_date") {{ $moment(item.approved_date).format('YYYY-MM-DD, HH:mm:ss') }}
                        td.text-right
                          span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.created_date") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
    .row(v-if="selectedAffiliateID")  
      .col-12
        .card.card-secondary
          .card-header
            i.fa.fa-user
            span.ml-1.font-weight-bold(:title="$t('ui.member')") {{ $t("ui.member") }}
          .card-body
            .row
              .col-md-10.col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRowMbm"
                  :per-page="getPageSize"
                  v-model="currentPageMbm"
                  @input="changedPageMbm($event)")
              .col-md-2.col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSizeMbm" size="sm")
              .col-md-12.col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="7%" @click="sortOrder('account_id','mbm')")
                          span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                          .float-right
                            i(:class="changeSortKey('account_id','mbm')")
                        th(width="6%" @click="sortOrder('contact_phone','mbm')")
                          span(:title="$t('ui.contact_phone')") {{ $t("ui.contact_phone") }}
                          .float-right
                            i(:class="changeSortKey('contact_phone','mbm')")
                        th(width="5%" @click="sortOrder('signup_ip','mbm')")
                          span(:title="$t('ui.signup_ip')") {{ $t("ui.signup_ip") }}
                          .float-right
                            i(:class="changeSortKey('signup_ip','mbm')")
                        th.text-center(width="6%")
                          span(:title="$t('ui.account_verified')") {{ $t("ui.account_verified") }}
                        th.text-right(width="5%" @click="sortOrder('verified_date','mbm')")
                          span(:title="$t('ui.verified_date')") {{ $t("ui.verified_date") }}
                          .float-right
                            i(:class="changeSortKey('verified_date','mbm')")
                        th.text-right(width="7%" @click="sortOrder('created_date','mbm')")
                          span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                          .float-right
                            i(:class="changeSortKey('created_date','mbm')")
                    tbody.clusterize-content
                      tr(v-if="memberList.length == 0")
                        td(colspan="7").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in memberList")
                        td.text-center
                          span(:title="((currentPageMbm - 1) * getPageSize + index + 1)") {{ ((currentPageMbm - 1) * getPageSize + index + 1) }}
                        td
                          //- span.font-weight-bold(:title="item.account_id") {{ item.account_id }}
                          b-link(href="javascript:void(0);" @click="onInfo(item)") {{ item.account_id }}
                        td
                          span(:title="item.contact_phone") {{ item.contact_phone }}
                        td
                          span(:title="item.signup_ip") {{ item.signup_ip }}
                        td.text-center
                          span
                            i(:class="{'fas fa-check text-info': item.account_verified, 'fas fa-times text-warning': !item.account_verified  }")
                        td.text-right
                          span(:title="$moment(item.verified_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.verified_date") {{ $moment(item.verified_date).format('YYYY-MM-DD, HH:mm:ss') }}
                        td.text-right
                          span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.created_date") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}

  editaffiliate(ref="editaffiliate" :item="editSelectedAffiliate" :operatorID="selectedOperatorID" @clicked="afterEditAffiliate" @failed="handleFailed")
  resetpasswordaffiliate(ref="resetpasswordaffiliate" :item="editSelectedAffiliate" :operatorID="selectedOperatorID" @clicked="afterResetPasswordAffiliate" @failed="handleFailed")
  walletadjustaffiliate(ref="walletadjustaffiliate" :item="editSelectedAffiliate" :operatorID="selectedOperatorID" @clicked="afterWalletAdjustAffiliate" @failed="handleFailed")
  updatecommaffiliate(ref="updatecommaffiliate" :item="editSelectedAffiliate" :operatorID="selectedOperatorID" @clicked="afterUpdateCommAffiliate" @failed="handleFailed")
  updatecarryoveraffiliate(ref="updatecarryoveraffiliate" :item="editSelectedAffiliate" :operatorID="selectedOperatorID" @clicked="afterUpdateCarryOverAffiliate" @failed="handleFailed")
  
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import editaffiliate from "@/components/affiliate/editAffiliate.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import resetpasswordaffiliate from "@/components/affiliate/resetPasswordAffiliate.vue";
import walletadjustaffiliate from "@/components/affiliate/walletAdjustAffiliate.vue";
import updatecommaffiliate from "@/components/affiliate/updateCommAffiliate.vue";
import updatecarryoveraffiliate from "@/components/affiliate/updateCarryOverAffiliate.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    editaffiliate,
    resetpasswordaffiliate,
    walletadjustaffiliate,
    updatecommaffiliate,
    updatecarryoveraffiliate,
  },
  data: () => ({
    loading: false,
    affiliateList: [],
    memberList: [],
    lines: [],
    currentPageAff: 1,
    totalRowAff: 0,
    currentPageMbm: 1,
    totalRowMbm: 0,
    searchType: "account_id",
    searchData: null,
    accountStatus: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedAffiliate: null,
    sortKeyAff: "account_id",
    sortTypeAff: "asc",
    sortKeyMbm: "account_id",
    sortTypeMbm: "asc",
    selectedAffiliateAccType: "",
    selectedOperatorID: "",
    selectedAffiliateID: "",
    selectedMemberID: ""
  }),
  computed: {
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_affiliate");
    },
    accountID() {
      return this.$store.getters.accountId;
    },
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
  },
  mounted: function() {
    this.getAffiliateList(true);
  },
  destroyed: function() {
    this.$store.dispatch("user/setSelectedMemberID", null);
  },
  methods: {
    redirectDailywinloseAff(e) {
      this.$router.push('/affiliate/dailyWinLoseAffiliate')
    },
    redirectDailyDepositAff(e) {
      this.$router.push('/affiliate/dailyDepositAffiliate')
    },
    redirectAffReport(e) {
      this.$store.dispatch("user/setSelectedOperatorID", this.accountID);
      this.$store.dispatch("user/setSelectedAffiliateID", e.account_id);
      this.$router.push('/affiliate/affiliateReport')
    },
    initSearchData() {
      if(!['account_status'].includes(this.searchType)) {
        this.searchData = null;
      } else {
        this.accountStatus = "";
      }

      this.getListing()
    },
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    showActionColumn() {
      return this.showActionButton('editaff') || this.showActionButton('updatecarryoveraff')
              || this.showActionButton('walletadjustaff') || this.showActionButton('updatecomissionaff') || this.showActionButton('moveaff')
              || this.showActionButton('resetpasswordaff') || this.showActionButton('unblockaff')
    },
    sortOrder(key, type) {
      if (type == 'aff') {
        if (this.sortKeyAff == key)
          this.sortTypeAff = this.sortTypeAff == 'asc' ? 'desc' : 'asc';
        else {
          this.sortKeyAff = key;
          this.sortTypeAff = 'asc';
        }

        this.getAffiliateList(true);
      } else if (type == 'mbm') {
        if (this.sortKeyMbm == key)
          this.sortTypeMbm = this.sortTypeMbm == 'asc' ? 'desc' : 'asc';
        else {
          this.sortKeyMbm = key;
          this.sortTypeMbm = 'asc';
        }

        this.getMemberList(true);
      }
    },
    changeSortKey(key, type) {
      if (type == 'aff') {
        if (this.sortKeyAff != key)
          return 'fas fa-sort';
        else if (this.sortKeyAff == key && this.sortTypeAff == 'asc')
          return 'fa fa-sort-up';
        else if (this.sortKeyAff == key && this.sortTypeAff == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'mbm') {
        if (this.sortKeyMbm != key)
          return 'fas fa-sort';
        else if (this.sortKeyMbm == key && this.sortTypeMbm == 'asc')
          return 'fa fa-sort-up';
        else if (this.sortKeyMbm == key && this.sortTypeMbm == 'desc')
          return 'fa fa-sort-down';
      }
    },
    drillIn: function (item, mode, id) {
      this.affiliateList = []
      this.memberList = []
      if(item == 'company') {
        this.selectedAffiliateID = "";
      }

      if(mode == 'operator') {
        this.selectedAffiliateID = "";
      }

      if(mode == 'affiliate') {
        this.selectedAffiliateID = item.account_id;
        this.selectedAffiliateAccType = item.account_type;
      }

      this.searchType = "account_id";
      this.searchData = null;
      this.accountStatus = "";
      this.getListing();
    },
    onMoveAffiliate: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.move_affiliate_confirm", { name: item.account_id, operator: this.accountID }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmMove(item);
          }
        });
    },
    confirmMove: function(item) {
      let url = config.accountMoveAffUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.accountID,
        account_id: item.account_id
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getAffiliateList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getListing() {
      this.getAffiliateList(true);
      if(this.selectedAffiliateID) {
        this.getMemberList(true);
      }
    },
    onInfo(e) {
      this.$store.dispatch("user/setSelectedOperatorID", this.accountID);
      this.$store.dispatch("user/setSelectedMemberID", e.account_id);
      window.open(window.location.origin + "/account/settings", '_blank');
    },
    onResetPasswordAffiliate(e) {
      this.editSelectedAffiliate = e;
      this.$refs.resetpasswordaffiliate.$refs.resetPasswordAffiliate.show();
    },
    onEditAffiliate(e) {
      this.editSelectedAffiliate = e;
      this.$refs.editaffiliate.$refs.editAffiliate.show();
    },
    onAdjustAffiliate(e) {
      this.editSelectedAffiliate = e;
      this.$refs.walletadjustaffiliate.$refs.walletAdjustAffiliate.show();
    },
    onUpdateCommAffiliate(e) {
      this.editSelectedAffiliate = e;
      this.$refs.updatecommaffiliate.$refs.updateCommAffiliate.show();
    },
    onSubAccDetailAffiliate(e) {
      this.editSelectedAffiliate = e;
      this.$refs.subaccdetailaffiliate.$refs.subAccDetailAffiliate.show();
    },
    onUpdateCarryOverAffiliate(e) {
      this.editSelectedAffiliate = e;
      this.$refs.updatecarryoveraffiliate.$refs.updateCarryOverAffiliate.show();
    },
    getAffiliateList: function(isSearch) {
      let url = config.accountListAffUrl();

      if (isSearch) this.currentPageAff = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.accountID,
        affiliate_id: this.selectedAffiliateID,
        sort_key: this.sortKeyAff,
        sort_type: this.sortTypeAff,
        page_number: this.currentPageAff,
        page_size: this.getPageSize,
      };

      if (this.searchData) {
        if (this.searchType == "account_id") {
          json.search_id = this.searchData.trim();
        } else if (this.searchType == "affiliate_code") {
          json.affiliate_code = this.searchData.trim();
        } else if (this.searchType == "contact_phone") {
          json.contact_phone = this.searchData.trim();
        }
      } else {
        if (this.searchType == "account_status") {
          json.account_status = this.accountStatus;
        }
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.affiliateList = response.data.ds.list;
                if (response.data.ds.line.length > 0) {
                  this.lines = response.data.ds.line.sort(function(a, b) {
                    return a.account_type - b.account_type;
                  });
                }
                else
                  this.lines = [];
                
                this.totalRowAff = this.affiliateList.length > 0 ? this.affiliateList[0].totalrows : 0;
              } else {
                // this.clearTotal()
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getMemberList: function(isSearch) {
      let url = config.memberListAffUrl();

      if (isSearch) this.currentPageMbm = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.accountID,
        account_id: this.selectedAffiliateID,
        sort_key: this.sortKeyMbm,
        sort_type: this.sortTypeMbm,
        page_number: this.currentPageMbm,
        page_size: this.getPageSize,
      };

      if (this.searchData) {
        if (this.searchType == "account_id") {
          json.search_id = this.searchData.trim();
        } 
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.memberList = response.data.dt;
                this.totalRowMbm = this.memberList.length > 0 ? this.memberList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onUnblockAffiliate: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.unblock"),
          text: this.$t("message.unblock_affiliate_confirm", { name: item.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmUnblockAffiliate(item);
          }
        });
    },
    confirmUnblockAffiliate: function(item) {
      let url = config.accountProfileUnblockAffUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        login_id: item.account_id,
        operator_id: this.accountID,
      };

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getAffiliateList();
                this.$helpers.showDialog(this.$t("ui.unblock_affiliate"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    changedAffiliateStatus: function(affiliate, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_affiliate_status_confirm", { name: affiliate.account_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmAffiliateStatus(affiliate, eventStatus);
          } else {
            this.getAffiliateList();
          }
        });
    },
    confirmAffiliateStatus: function(affiliate, status) {
      let url = config.accountStatusUpdateAffUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.accountID,
        account_id: affiliate.account_id,
        new_status: status
      };

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getAffiliateList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    afterResetPasswordAffiliate: function() {
      this.getAffiliateList();
      this.$helpers.showDialog(this.$t("ui.combine.reset_password"), this.$t("message.success"), "success");
    },
    afterEditAffiliate: function() {
      this.getAffiliateList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_affiliate"), this.$t("message.success"), "success");
    },
    afterWalletAdjustAffiliate: function() {
      this.getAffiliateList();
      this.$helpers.showDialog(this.$t("ui.combine.wallet_adjust"), this.$t("message.success"), "success");
    },
    afterUpdateCommAffiliate: function() {
      this.getAffiliateList();
      this.$helpers.showDialog(this.$t("ui.combine.update_comm"), this.$t("message.success"), "success");
    },
    afterUpdateCarryOverAffiliate: function() {
      this.getAffiliateList();
      this.$helpers.showDialog(this.$t("ui.combine.update_carry_over"), this.$t("message.success"), "success");
    },
    changedPageSizeAff: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPageAff = 1;
      this.getAffiliateList(true);
    },
    changedPageAff: function(pageNo) {
      this.currentPageAff = pageNo;
      this.getAffiliateList();
    },
    changedPageSizeMbm: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPageMbm = 1;
      this.getMemberList(true);
    },
    changedPageMbm: function(pageNo) {
      this.currentPageMbm = pageNo;
      this.getMemberList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>